import type { OsNavItem } from './types';

export function matchesPath(path: string | undefined, currentPath: string): boolean {
  if (!path) return false;

  const base = path.split('?')[0];
  return currentPath === base || currentPath.startsWith(`${base}/`);
}

// Whether the page belongs to the item: its own path or one of its activePaths. The rail and the mobile
// menu both go through this, so they agree on which item is active.
export function itemMatchesPath(item: OsNavItem, currentPath: string): boolean {
  return [item.path, ...(item.activePaths ?? [])].some(path => matchesPath(path, currentPath));
}

export interface NavItemState {
  activeChild?: OsNavItem;
  isActive: boolean;
  isCurrent: boolean;
}

export function navItemState(item: OsNavItem, currentPath: string): NavItemState {
  const activeChild = item.children?.find(child => itemMatchesPath(child, currentPath));
  const isActive = !!activeChild || itemMatchesPath(item, currentPath);

  return { activeChild, isActive, isCurrent: isActive && !activeChild };
}
